<template>
  <div class="recapitulatif">
    <div class="eleve">
      <h4 class="sous_titre_recap">1. Renseignements concernant l'élève</h4>
      <div class="row">
        <span class="col-6 donnees_recap">Nom</span>
        <span class="col-6 donnees_recap">{{ nomEleve }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Prénom</span>
        <span class="col-6 donnees_recap">{{ prenomEleve }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Date de naissance</span>
        <span class="col-6 donnees_recap">{{ naissanceEleve }}</span>
      </div>
    </div>

    <div class="parents">
      <h4 class="sous_titre_recap">2. Renseignements concernant les parents</h4>

      <div class="row">
        <span class="col-6 donnees_recap">Nom et Prénom</span>
        <span class="col-6 donnees_recap">{{ nomParent }} {{ prenomParent }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Adresse</span>
        <span class="col-6 donnees_recap"
          >{{ adresse }} {{ codePostal }} à {{ commune }} <br />{{ complement }}</span
        >
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Garde alternée</span>
        <span v-if="gardeAlternee === 'true'" class="col-6 donnees_recap">Oui</span>
        <span v-if="gardeAlternee === 'false'" class="col-6 donnees_recap">Non</span>
      </div>

      <hr />

      <div v-if="gardeAlternee === 'true'">
        <div class="row">
          <span class="col-6 donnees_recap">Nom et Prénom du deuxième parent</span>
          <span class="col-6 donnees_recap">{{ nomParents2 }}</span>
        </div>

        <hr />

        <div class="row">
          <span class="col-6 donnees_recap">Adresse du deuxième parent</span>
          <span class="col-6 donnees_recap"
            >{{ adresseParent2 }} {{ codePostalParent2 }} à {{ communeParent2 }} <br />{{
              complementParent2
            }}</span
          >
        </div>

        <hr />
      </div>

      <div class="row">
        <span class="col-6 donnees_recap">Numéro de Téléphone</span>
        <span class="col-6 donnees_recap">{{ telephone }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-sm-6 col-12 donnees_recap">Adresse mail</span>
        <span class="col-sm-6 col-12 donnees_recap">{{ email }}</span>
      </div>
    </div>

    <div class="scolarite">
      <h4 class="sous_titre_recap">3. Scolarité - Année 2026-2027</h4>

      <div class="row">
        <span class="col-6 donnees_recap">Établissement</span>
        <span class="col-6 donnees_recap">{{ etablissement }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Classe</span>
        <span class="col-6 donnees_recap">{{ classe }}</span>
      </div>

      <hr />

      <div class="row">
        <span class="col-6 donnees_recap">Régime</span>
        <span class="col-6 donnees_recap">{{ regime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps([
  'nomEleve',
  'prenomEleve',
  'naissanceEleve',
  'nomParent',
  'prenomParent',
  'adresse',
  'complement',
  'codePostal',
  'commune',
  'telephone',
  'email',
  'gardeAlternee',
  'etablissement',
  'classe',
  'regime',
  'nomParents2',
  'adresseParent2',
  'codePostalParent2',
  'communeParent2',
  'complementParent2',
])
</script>

<style scoped lang="scss">
@import '../sass/variables';

.recapitulatif {
  .eleve,
  .parents,
  .scolarite {
    margin-top: 2rem;
    margin-bottom: 2rem;

    .sous_titre_recap {
      margin-bottom: 1rem;
    }

    .donnees_recap {
      font-size: 18px;
    }
  }
}
</style>